import { OptionType } from 'components/CustomSelect/types';
import { ClearAttributeMappingsPayload } from 'services/sheet-attribute-manager/models/sheet-attribute-manager.interface';
import SheetAttributeManager from '../../../services/sheet-attribute-manager/SheetAttributeManager';

export interface AttributeOptionType extends OptionType<string> {}

export interface FinancialsMappingClearRequest {
    source?: ClearAttributeMappingsPayload;
}

export enum AttributeMappingType {
    SINGLE_CELL = 'single_cell',
    GRID_INDICATORS = 'grid_indicators',
    SINGLE_CELL_AND_GRID_INDICATORS = 'single_cell_and_grid_indicators'
}

export interface AttributeReferenceConfig {
    columns: AttributeOptionType[];
    rows: AttributeOptionType[];
    selectionMode: AttributeMappingType;
    attributeMapper?: SheetAttributeManager
}

export const NEGATIVE_PREFIX = 'neg-';
